<template>
  <div>
    <success-fade-alert ref="alert" :msg="alerts.success" />
    <fade-alert-danger ref="danger" :msg="alerts.error" />

    <b-overlay :show="!isInputsEnabled" rounded="lg" opacity="0.6">
      <template #overlay>
        <div class="d-flex align-items-center">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ $t("geral.sendingData") }}</strong>
        </div>
      </template>

      <b-form-textarea
        id="input-descriptionApproval"
        v-model="approvalDescription"
        placeholder="Escrever a descrição da aprovação..."
        :disabled="!isInputsEnabled"
      />

      <div>
        <b-row>
          <b-col>
            <camera-button
              :lang="$i18n.locale"
              :disabled="!isInputsEnabled"
              :allow-documents="true"
              @update-image-src="fileAdd"
            >
            </camera-button>
          </b-col>
          <b-col class="text-right">
            <span v-if="isCommentLengthValid">{{ commentLength }}/500</span>
            <span v-else class="text-danger">
              Descrição da aprovação maior que o permitido.
              {{ commentLength }}/500
            </span>
          </b-col>
        </b-row>

        <b-row
          class="text-center"
          v-if="attachments != null && attachments.length > 0"
        >
          <b-col md="3" v-for="(attachment, i) in attachments" :key="i">
            <base-attachment-viewer
              class="ml-3 mb-3"
              :attachment="attachment"
              :discard-visible="isInputsEnabled"
              @discard="fileRemove"
            ></base-attachment-viewer>
            <!-- <base-attachment-item
              :attachment="attachment.attachment"
              :discard-visible="isInputsEnabled"
              @discard="fileRemove"
            >
            </base-attachment-item> -->
          </b-col>
        </b-row>

        <div>
          <b-button
            size="sm"
            class="mr-2"
            variant="green"
            :disabled="!isInputsEnabled"
            @click="saveComment"
          >
            {{ $t("checklist.form.ApprovalPendencies") }}
          </b-button>
          <b-button
            size="sm"
            class="mr-2"
            variant="danger"
            :disabled="!isInputsEnabled"
            @click="typingCancel"
          >
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
// import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
import CameraButton from "@/components_rms/CameraButton.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import BaseAttachmentViewer from "@/components_rms/base/BaseAttachmentViewer.vue";

export default {
  name: "PendencyApproval",
  components: {
    // BaseAttachmentItem,
    CameraButton,
    FadeAlertDanger,
    SuccessFadeAlert,
    BaseAttachmentViewer,
  },
  props: {
    pendencyId: Number,
  },
  data: function () {
    return {
      alerts: {
        error: "",
        success: "Pendencia aprovada com sucesso",
      },
      attachments: [],
      approvalDescription: "",
      isInputsEnabled: true,
    };
  },
  created: function () {},
  computed: {
    commentLength() {
      if (!this.approvalDescription) return 0;
      return this.approvalDescription.length;
    },
    isCommentLengthValid() {
      return this.commentLength <= 500;
    },
  },
  methods: {
    clearTyping() {
      this.attachments = [];
      this.approvalDescription = "";
    },
    fileAdd(newValue) {
      this.attachments.push({ attachment: newValue });
      this.$forceUpdate();
    },
    fileRemove(attachment) {
      for (let i = this.attachments.length - 1; i >= 0; i--) {
        if (this.attachments[i].attachment == attachment) {
          this.attachments.splice(i, 1);
          break;
        }
      }
      this.$forceUpdate();
    },
    saveComment() {
      this.isInputsEnabled = false;

      let pendencyApproval = {
        id: parseInt(this.pendencyId),
        approvalDescription: this.approvalDescription,
        attachments: [],
      };
      this.attachments.forEach((attach) => {
        let pendencyApprovalAttachment = {
          attachment: attach.attachment,
        };
        pendencyApproval.attachments.push(pendencyApprovalAttachment);
      });

      this.$apiChecklist
        .post("/pendencies/approvate/", pendencyApproval)
        .then((response) => {
          this.$refs.alert.show();
          this.isInputsEnabled = true;
          this.clearTyping();
          this.$emit("after-approval");
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            this.alerts.error = `${error.response.status} - ${error.response.statusText}`;
            this.$refs.danger.show();
            this.isInputsEnabled = true;
          } else {
            this.alerts.error = error;
            this.$refs.danger.show();
            this.isInputsEnabled = true;
          }
        });
    },
    typingCancel() {
      this.clearTyping();
      this.$emit("cancel-approval");
    },
  },
};
</script>

